import { _MODULE_NAME } from './constants';

export const LOGIN = `${_MODULE_NAME}/LOGIN`;
export function login({ accessToken, expiresIn, fullAccess } = {}) {
	return {
		type: LOGIN,
		payload: { accessToken, expiresIn, fullAccess },
	};
}

export const SET_FULL_ACCESS = `${_MODULE_NAME}/SET_FULL_ACCESS`;
export const setFullAccess = () => ({
	type: SET_FULL_ACCESS,
});

export const USER_LOGOUT = `${_MODULE_NAME}/USER_LOGOUT`;

// * @param {Object} settings
// * @param {string} settings.variant - logout variant, used to determine which logout flow to use - undefined or TECHNICAL
// * @param {array} settings.cleanUpConfig - config for app clean up
export const userLogoutAction = (settings) => ({
	type: USER_LOGOUT,
	payload: {
		/**
		 * logoutAction is handled in logout saga. Since sagas runs as last invocation during action
		 * handling, other redux middleware or action dispatcher can append logout tasks (promises) into
		 * `onLogout` array. Logout saga will wait for all promises to settle (fulfill or reject).
		 */
		onLogout: [],
		variant: settings?.variant,
		cleanUpConfig: settings?.cleanUpConfig,
	},
});
export const SESSION_EXPIRED = `${_MODULE_NAME}/SESSION_EXPIRED`;
export const sessionExpiredAction = () => ({ type: SESSION_EXPIRED });

export const UPDATE_LOGIN_STATUS = `${_MODULE_NAME}/UPDATE_LOGIN_STATUS`;
export function updateLoginStatus(isLoggedIn) {
	return { type: UPDATE_LOGIN_STATUS, payload: { isLoggedIn } };
}

export const USER_LOGGED_IN = `${_MODULE_NAME}/USER_LOGGED_IN`;
export function userLoggedIn(user) {
	return { type: USER_LOGGED_IN, payload: { user } };
}

export const LOGIN_EXPIRES_SOON = `${_MODULE_NAME}/LOGIN_EXPIRES_SOON`;
export function loginExpiresSoonAction(loginExpiresSoon) {
	return { type: LOGIN_EXPIRES_SOON, payload: { loginExpiresSoon } };
}
